import React from "react";

export default function NewYearFrame5({ frameTextToggle, children }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 2000 2000"
      width="300"
      height="300"
      fill="none"
    >
      <g transform={frameTextToggle}>
        <defs>
          <style>
            {
              ".cls-5ne2{fill:#108a6a}.cls-5ne4{fill:#f2673f}.cls-5ne5,.cls-5ne6,.cls-5ne7,.cls-5ne8,.cls-5ne9{fill:none;stroke-miterlimit:10}.cls-5ne5,.cls-5ne6,.cls-5ne7,.cls-5ne8{stroke:#108a6a}.cls-5ne5,.cls-5ne6{stroke-width:7.29px}.cls-5ne6{stroke-linecap:round}.cls-5ne7{stroke-width:3.1px}.cls-5ne8{stroke-width:2.52px}.cls-5ne9{stroke:#f2673f;stroke-width:4.86px}"
            }
          </style>
        </defs>
        <g
          id="\u0421\u043B\u043E\u0439_8"
          data-name="\u0421\u043B\u043E\u0439 8"
        >
          <path
            d="M216.18 187.08V1790.7l17.95 21.75.28.35h1607.52V187.08Zm1578.13 1560.36L1772 1765.2H263.79V284.32l62.38-49.64h1468.14Z"
            style={{
              fill: "#fce9d2",
            }}
          />
          <path
            d="M362.13 187.08 216.18 307.46V187.08h145.95zM263.79 479.64v182.91l-31.55 26.02-16.06 13.25V518.91l47.61-39.27zM840.18 187.08l-57.7 47.6H560.76l57.7-47.6h221.72zM263.79 873.99v182.89l-47.61 39.27V913.27l47.61-39.28zM1318.21 187.08l-57.71 47.6h-221.72l57.71-47.6h221.72zM263.79 1268.33v182.89l-47.61 39.27V1307.6l47.61-39.27zM1796.24 187.08l-57.7 47.6h-221.71l57.71-47.6h221.7zM361.18 1765.2l-57.71 47.6h-69.78c-5.85 0-11.72.08-17.57.12 0-7.32 0-14.9.06-22.22q.09-44.39 0-88.77l47.61-39.28v102.55ZM1841.93 360.84v182.9l-47.62 39.27v-182.9l47.62-39.27zM839.24 1765.2l-57.71 47.6H559.81l57.71-47.6h221.72zM1841.93 755.19v182.88l-47.62 39.27V794.46l47.62-39.27zM1317.26 1765.2l-57.7 47.6h-221.72l57.7-47.6h221.72zM1841.93 1149.52v182.89l-47.62 39.28v-182.9l47.62-39.27zM1841.93 1543.86v182.88l-104.34 86.06h-221.71l57.71-47.6h198.39l22.33-17.76v-164.31l47.62-39.27z"
            className="cls-5ne2"
          />
          <path
            d="M263.79 1402.68v60.54l-47.61 37.9v-60.54l47.61-37.9z"
            style={{
              fill: "#fff",
            }}
          />
          <path
            d="M1841.93 187.08v20.15l-47.62 37.89v-10.44h-62.96l59.81-47.6h50.77zM369.57 1765.2l-59.8 47.6h-76.08l.44-.35 59.37-47.25h76.07zM1841.93 532.85v60.56l-47.62 37.89v-60.56l47.62-37.89zM862.4 1765.2l-59.81 47.6h-76.07l59.81-47.6h76.07zM1841.93 925.08v60.54l-47.62 37.89v-60.54l47.62-37.89zM1355.22 1765.2l-59.8 47.6h-76.07l59.81-47.6h76.06zM1841.93 1317.3v60.55l-47.62 37.89v-60.54l47.62-37.9zM1841.93 1709.54v60.53l-53.69 42.73h-76.07l59.81-47.6 22.33-17.76 47.62-37.9zM263.79 1003.86v60.54l-47.61 37.89v-60.54l47.61-37.89zM1366.12 187.08l-59.81 47.6h-76.07l59.8-47.6h76.08zM263.79 602.91v60.55l-31.55 25.11-16.06 12.78v-60.54l47.61-37.9zM862.35 187.08l-59.81 47.6h-76.07l59.8-47.6h76.08zM385.98 187.08l-59.81 47.6-62.38 49.64-47.61 37.9v-60.56l93.7-74.58h76.1z"
            className="cls-5ne4"
          />
          <path
            d="M1753.06 1694.81a858.93 858.93 0 0 1-297 0q28.08-72.24 56.2-144.46h-1.22l-35.26.56q16.44-35.78 32-74.71c13.38-33.57 24.94-66.07 35-97.26q-14.88.7-29.76 1.43 15.8-28.41 31.12-59.27 9.16-18.51 18-37.9c1.26-2.73 2.5-5.45 3.72-8.19 15-33.46 27.77-65.68 38.69-96.41 10.92 30.73 23.7 63 38.7 96.41 16.81 37.52 34.66 72.67 52.84 105.36q-14.89-.73-29.78-1.43 4.14 12.86 8.65 26 4.76 14 10 28.33 7.72 21.12 16.35 42.9c10.32 25.94 21 50.86 32 74.71l-36.48-.58 8 20.56q8 20.44 15.91 40.88 16.15 41.57 32.32 83.07Z"
            className="cls-5ne5"
          />
          <path
            d="M1533.15 1379.42a268 268 0 0 0 120.17-41.55M1507.24 1550.78a291.27 291.27 0 0 0 86-22.14 296.69 296.69 0 0 0 48.86-26.67"
            className="cls-5ne6"
          />
          <path
            d="M1582.27 1305.4a22.3 22.3 0 1 1-22.29-22.3 19.55 19.55 0 0 1 2.19.12 22.3 22.3 0 0 1 20.1 22.18ZM1686.72 1424.65A22.26 22.26 0 1 1 1675 1405a22.35 22.35 0 0 1 11.72 19.65Z"
            className="cls-5ne4"
          />
          <circle cx={1524.28} cy={1513.73} r={22.3} className="cls-5ne4" />
          <circle cx={1582.28} cy={1428.67} r={11.15} className="cls-5ne4" />
          <circle cx={1615.73} cy={1596.86} r={11.15} className="cls-5ne4" />
          <circle cx={1609.79} cy={1250.51} r={11.15} className="cls-5ne4" />
          <path
            d="M1731.33 1592.83a22.33 22.33 0 1 1-22.3-22.31 22.27 22.27 0 0 1 22.3 22.31Z"
            className="cls-5ne4"
          />
          <circle cx={1524.28} cy={1646.69} r={22.3} className="cls-5ne4" />
          <path d="M1604.58 1764.68v-56.94" className="cls-5ne5" />
          <path
            d="M487.19 299.76s7.73 34.45-2.23 64.86M434.08 383q1.91 3.6 3.8 7.35c1.14 2.23 2.28 4.52 3.41 6.84.64 1.29 1.27 2.59 1.89 3.91.8 1.65 1.58 3.32 2.36 5q4.68 10.06 8.62 19.65c.56 1.36 1.1 2.7 1.64 4 1-1 2-2 3-3.05 6.29-6.26 13.2-12.78 20.79-19.42l2.46-2.13q7.47-6.45 15.79-13a456.72 456.72 0 0 1 38.83-27.36 458.4 458.4 0 0 1 7.3-4.51"
            className="cls-5ne7"
          />
          <path
            d="M495 297.43c.57 3.85-2.28 7.57-6.6 9a12 12 0 0 1-2 .48c-5.42.79-10.35-2.15-11-6.59s3.21-8.67 8.62-9.48 10.3 2.16 10.98 6.59Z"
            className="cls-5ne4"
          />
          <path
            d="M398.36 448.72c2.16 1.42 4.41 2.95 6.74 4.62l.64.47a165.36 165.36 0 0 1 15.45 12.71 161.52 161.52 0 0 1 17.16 18.59c.47.57.91 1.13 1.34 1.7l.82 1.07.34-.19q6.36-3.35 12.72-6.72 43.86-23.18 87.72-46.4l7.62-4"
            className="cls-5ne7"
          />
          <path
            d="M443.9 381.53a8 8 0 0 1-3.86 7.68 10.26 10.26 0 0 1-2.16 1.12 12.05 12.05 0 0 1-2.61.69c-5.42.79-10.35-2.17-11-6.59s3.22-8.69 8.63-9.48a11.74 11.74 0 0 1 3.4 0c3.94.54 7.09 3.11 7.6 6.58ZM408.18 447.27a7.63 7.63 0 0 1-2.44 6.54l-.5.44a9 9 0 0 1-1.36 1 11.53 11.53 0 0 1-4.33 1.54 12 12 0 0 1-2.15.12 10.56 10.56 0 0 1-5-1.35 7.47 7.47 0 0 1-3.9-5.36 7.61 7.61 0 0 1 2.71-6.77 11.62 11.62 0 0 1 12.11-1.92 7.71 7.71 0 0 1 4.86 5.76Z"
            className="cls-5ne4"
          />
          <path
            d="M428.83 549.62s1.6-13 5.74-33.67c.95-4.69 2-9.8 3.23-15.23.11-.43.19-.87.3-1.31.14-.64.3-1.3.44-2 .09-.36.18-.74.27-1.13.05-.2.09-.42.15-.63a2.74 2.74 0 0 1 .09-.39c.28-1.22.57-2.46.87-3.71s.61-2.57.93-3.88c2.6-10.64 5.69-22.21 9.35-34.36q1.77-5.94 3.75-12.06 2.3-7.17 4.89-14.53c1.36-3.93 2.8-7.88 4.28-11.86 15.11-40.28 36.28-82.61 65.52-116.21 1.3-1.5 2.61-3 4-4.43"
            className="cls-5ne7"
          />
          <path
            d="M550.1 367.58c-3.78 2.81-9.55 1.84-12.92-2.16-.16-.19-.32-.4-.47-.6-2.85-3.94-2.38-9.07 1.2-11.76 3.78-2.82 9.56-1.86 12.91 2.14s3.04 9.54-.72 12.38ZM540.86 297c-2.69 3.39-8 4-12.22 1.65a8.42 8.42 0 0 1-.9-.56c-4.37-3-5.58-8.44-2.69-12.06s8.75-4.12 13.12-1.09 5.57 8.46 2.69 12.06ZM555 437.79c-3.77 2.83-9.55 1.86-12.92-2.14a11.45 11.45 0 0 1-.79-1.08c-2.48-3.86-1.9-8.71 1.53-11.28 3.77-2.81 9.55-1.86 12.92 2.14s3.04 9.57-.74 12.36Z"
            className="cls-5ne4"
          />
          <path
            d="M355.23 358.06s3.66 30.38 18.75 51.23M413.91 406.2c-.26 2.38-.5 4.79-.73 7.25-.5 5-.91 10.1-1.26 15.37-.13 2-.26 4-.36 6q-.31 5.58-.47 10.94v.84c0 .86-.05 1.72-.08 2.56s0 1.39-.05 2.07v.24l-.56-.26c-2.53-1.19-5.17-2.37-7.89-3.55q-2.37-1-4.85-2c-8.09-3.32-16.9-6.49-26.45-9.37a291.16 291.16 0 0 0-34.74-8.15c-2.15-.37-4.28-.7-6.35-1"
            className="cls-5ne8"
          />
          <path
            d="M356.76 363.75c-.18.06-.37.11-.58.16-3.82.92-7.35-1.08-8-4.69-.71-3.8 2-7.91 6.05-9.19s7.9.73 8.61 4.52-2.02 7.91-6.08 9.2Z"
            className="cls-5ne4"
          />
          <path
            d="M456.61 446.24c-1.26 2.07-2.56 4.3-3.88 6.71a163.8 163.8 0 0 0-7.57 15.68c-1.9 4.51-3.49 8.84-4.8 12.9-.42 1.25-.8 2.47-1.16 3.67s-.77 2.58-1.12 3.82c0 .15-.07.29-.11.43-.15.56-.31 1.12-.45 1.67-.06.21-.1.4-.16.6-.07.3-.16.61-.23.91l-.81-.07-36.34-3-48.31-3.92-6.46-.53"
            className="cls-5ne8"
          />
          <path
            d="M415.2 413.07a8.16 8.16 0 0 1-2 .38 6.1 6.1 0 0 1-6.6-4.92c-.71-3.8 2-7.91 6.05-9.19s7.9.74 8.61 4.54-2.02 7.9-6.06 9.19ZM457.9 453.11a2.68 2.68 0 0 1-.35.1 7.27 7.27 0 0 1-4.82-.26 5.88 5.88 0 0 1-3.46-4.38 7.31 7.31 0 0 1 .57-4.32 9.2 9.2 0 0 1 4.77-4.62 7.41 7.41 0 0 1 .71-.25c3.72-1.19 7.28.43 8.38 3.63a5.91 5.91 0 0 1 .25.9c.71 3.79-1.95 7.92-6.05 9.2Z"
            className="cls-5ne4"
          />
          <path
            d="M457.56 531.49a303.39 303.39 0 0 0-17.78-38.79l-.47-.84c-.43-.8-.88-1.61-1.34-2.41a.36.36 0 0 0-.05-.09l-.15-.27c-3.61-6.42-7.65-13-12.18-19.82-2.56-3.84-5.26-7.72-8.14-11.63-1.44-1.95-2.91-3.92-4.45-5.89-.65-.87-1.33-1.74-2-2.6l-1.51-1.91q-5.07-6.35-10.75-12.7-8.74-9.81-18.95-19.54a347 347 0 0 0-55.29-42.62c-1.28-.8-2.56-1.59-3.82-2.35"
            className="cls-5ne8"
          />
          <path
            d="M336.44 428.1c-.05.23-.11.45-.17.66-1.32 4.41-5.15 7.24-8.57 6.31s-5.11-5.25-3.79-9.65 5.15-7.24 8.57-6.32c3.24.9 4.93 4.83 3.96 9ZM325.14 371.4a8.13 8.13 0 0 1-.64 1c-2.37 3.28-6.19 4.56-8.94 2.83-3-1.88-3.57-6.65-1.29-10.63s6.59-5.68 9.58-3.8 3.58 6.62 1.29 10.6ZM351.67 485.69a10.11 10.11 0 0 1-.28 1.15c-1.31 4.4-5.16 7.22-8.58 6.3s-5.11-5.24-3.79-9.65 5.17-7.23 8.58-6.31c3.13.82 4.81 4.52 4.07 8.51Z"
            className="cls-5ne4"
          />
          <path
            d="M438.21 481.69c-.55.35-1.1.67-1.63 1l-1.35.81C414 496 406 496.31 402.79 493.85c-2.33-1.81-2.34-5.34-2.34-9.13a28.68 28.68 0 0 1 .61-5.72c1-5.06 3.47-10.29 7.83-11.7 6.66-2.16 17.14 4.8 27.66 13.08a3.36 3.36 0 0 1 .29.24h.06ZM469.91 502.13c-5 2.46-17.73-9.2-30.86-19.75l-.84-.69.4-.23.29-.18c10.42-7.53 21.45-9.74 26.82-5.85 3 2.19 3.9 6 5 10.91.87 3.95 3.1 13.87-.81 15.79Z"
            className="cls-5ne9"
          />
          <path
            d="M401.94 510.31a42.88 42.88 0 0 0 16.15-4.31 41.63 41.63 0 0 0 11.2-8.11 45.65 45.65 0 0 0 6.42-8.16c.71-1.12 1.24-2.1 1.63-2.86a99.29 99.29 0 0 0 15.7 37 96.92 96.92 0 0 0 12.87 15"
            style={{
              stroke: "#f2673f",
              strokeWidth: "4.86px",
              strokeLinecap: "round",
              fill: "none",
              strokeMiterlimit: 10,
            }}
          />
          <path
            d="m326.17 234.68-62.38 49.64v-49.64h62.38zM1794.31 1747.44v17.76h-22.33l22.33-17.76z"
            className="cls-5ne4"
          />
        </g>
        {children}
      </g>
    </svg>
  );
}
